/**
 * Production Phaser build: `phaser-core` (renderer, scenes, input, tweens, textures, text,
 * image, sprite, graphics…) plus the extra game objects this game uses. Physics, tilemaps,
 * sound, shapes, meshes, video and the rest are left out. Aliased to `phaser` in
 * vite.config.ts for `vite build` only; dev serves the full prebuilt ESM.
 */
import Phaser from 'phaser/src/phaser-core.js';
import Container from 'phaser/src/gameobjects/container/Container.js';
import 'phaser/src/gameobjects/container/ContainerFactory.js';
import 'phaser/src/gameobjects/container/ContainerCreator.js';
import Zone from 'phaser/src/gameobjects/zone/Zone.js';
import 'phaser/src/gameobjects/zone/ZoneFactory.js';
import Particles from 'phaser/src/gameobjects/particles/index.js';
import 'phaser/src/gameobjects/particles/ParticleEmitterFactory.js';
import Clamp from 'phaser/src/math/Clamp.js';

Phaser.GameObjects.Container = Container;
Phaser.GameObjects.Zone = Zone;
Phaser.GameObjects.Particles = Particles;
Phaser.Math.Clamp = Clamp;

export const { AUTO, CANVAS, WEBGL, Game, Scene, Scale, Core, Animations, GameObjects, Input, Math, Textures, Time, Tweens, Structs, Cameras, Events } = Phaser;
export default Phaser;
